// Names — mix of Spanish/Latin first names typical of US Hispanic buyers
export const BUYER_NAMES = [
  'María G.',
  'Carlos R.',
  'Ana M.',
  'José H.',
  'Laura P.',
  'Miguel S.',
  'Sofia R.',
  'Daniel V.',
  'Camila L.',
  'Andrés P.',
  'Lucía F.',
  'Javier T.',
  'Valentina C.',
  'Sebastián O.',
  'Isabella N.',
  'Mateo B.',
  'Renata D.',
  'Diego A.',
  'Paula M.',
  'Tomás E.',
  'Emma K.',
  'Liam J.',
  'Olivia W.',
  'Noah B.',
  'Mia T.',
  'Ethan H.',
  'Aria F.',
  'Lucas R.',
  'Chloe N.',
  'Hannah D.',
]

// US cities for the “just purchased” line
export const US_CITIES = [
  'Miami, FL',
  'Los Angeles, CA',
  'New York, NY',
  'Chicago, IL',
  'Houston, TX',
  'Phoenix, AZ',
  'Philadelphia, PA',
  'San Antonio, TX',
  'San Diego, CA',
  'Dallas, TX',
  'San Jose, CA',
  'Austin, TX',
  'Jacksonville, FL',
  'Fort Worth, TX',
  'Columbus, OH',
  'Charlotte, NC',
  'Indianapolis, IN',
  'Seattle, WA',
  'Denver, CO',
  'Washington, DC',
  'Boston, MA',
  'Nashville, TN',
  'Orlando, FL',
  'Tampa, FL',
  'Atlanta, GA',
  'Las Vegas, NV',
  'Portland, OR',
  'Sacramento, CA',
  'Minneapolis, MN',
  'New Orleans, LA',
]

// Fallback products used ONLY when the scanner can't extract anything from the DOM.
// Distribution: 70% physical, 30% digital.
export interface ScannedProduct {
  title: string
  editionLabel?: string
  priceNumber: number
  priceText: string
  originalPriceText?: string // Strikethrough price (e.g. "$197 USD")
  thumbnailUrl?: string
  weight?: number // for weighted random selection
}

export const FALLBACK_PRODUCTS: ScannedProduct[] = [
  {
    title: 'Pack Despertar',
    editionLabel: 'Physical Book',
    priceNumber: 27,
    priceText: '$27 USD',
    weight: 0.7,
  },
  {
    title: 'Edición Digital',
    editionLabel: 'Digital Edition',
    priceNumber: 17,
    priceText: '$17 USD',
    weight: 0.3,
  },
]
